import { Modal, ELEMENT_SIZE } from 'ht-styleguide';

// Hooks
import { useSendAuthCode } from './LoginPasscode/LoginPasscode.hooks';

// Components
import { LoginFormPasswordless } from '../LoginFormPasswordless/LoginForm.Passwordless';
import { MODAL_LOGIN_PASSCODE, MODAL_LOGIN_PASSWORDLESS, useGetModalDataByName, useModalStoreActions } from '@store/client/store.modals';

export const LoginModalPasswordless = () => {
  /* Hooks */
  const sendAuthCode = useSendAuthCode();
  const { updateAppLevelModal } = useModalStoreActions();
  const modalData = useGetModalDataByName(MODAL_LOGIN_PASSWORDLESS);

  /* Methods */
  /* Close this modal */
  const closeModal = () => {
    updateAppLevelModal({ name: MODAL_LOGIN_PASSWORDLESS, visible: false });
  };
  /* Submit email and close & launch passcode entry on success */
  const onEmailSubmitSuccess = async ({ phoneLastFour = '', userInitials = '', email = '' }) => {
    updateAppLevelModal({ name: MODAL_LOGIN_PASSCODE, visible: true, data: { email, phoneLastFour, userInitials } });
    closeModal();

    await sendAuthCode({ email });
  };

  return (
    <Modal isVisible={modalData?.visible} hide={closeModal} header="Sign in" elementSize={ELEMENT_SIZE.MEDIUM}>
      <LoginFormPasswordless onSuccess={onEmailSubmitSuccess} />
    </Modal>
  );
};
